import { useRef, useState } from "react";
import { Platform, Text, TextInput as TextInputComponent, TouchableOpacity, View, } from "react-native";
import { useCustomTheme } from "../hooks/useCustomTheme";
import { CollapsibleView } from "./CollapsibleView";
import { Icon } from "./Icon";
import { ThemedText } from "./ThemedText";
import { styles } from "./styles/TextInput.styles";
export const TextInput = ({ value, placeholder, onChangeText, onBlur, error, type, icon, readonly = false, disabled = false, multiline = false, slotRight, description, isFocusedOverride, isHoveredOverride, reserveErrorSpace = true, testID, }) => {
    const inputRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const { colors, fonts } = useCustomTheme();
    const hasValue = value.length > 0;
    const isFocusActive = !disabled && (isFocusedOverride ?? isFocused);
    const isHoverActive = !disabled && (isHoveredOverride ?? isHovered);
    const borderColor = disabled
        ? colors.mutedBorder
        : error
            ? colors.danger
            : isFocusActive || isHoverActive
                ? colors.palette.spinach30
                : hasValue
                    ? colors.palette.spinach40
                    : colors.mutedBorder;
    const borderWidth = disabled
        ? 1
        : error
            ? undefined
            : isFocusActive || isHoverActive || hasValue
                ? 1
                : undefined;
    const hoverHandlers = Platform.OS === "web" && !disabled
        ? {
            onMouseEnter: () => setIsHovered(true),
            onMouseLeave: () => setIsHovered(false),
        }
        : undefined;
    const contentColor = disabled ? colors.muted : colors.text;
    const disabledContainerStyle = disabled && Platform.OS === "web"
        ? { cursor: "not-allowed" }
        : undefined;
    const disabledInputStyle = disabled && Platform.OS === "web"
        ? { cursor: "not-allowed" }
        : undefined;
    const focusInput = () => {
        if (readonly || disabled)
            return;
        inputRef.current?.focus();
    };
    const containerTouchHandlers = !readonly && !disabled
        ? {
            onTouchEnd: focusInput,
            ...(Platform.OS === "web" ? { onClick: focusInput } : {}),
        }
        : undefined;
    return (<View style={styles.formGroup} {...hoverHandlers}>
      <View {...(containerTouchHandlers ?? {})} style={[
            styles.inputContainer,
            multiline && styles.inputContainerMultiline,
            { borderColor },
            ...(borderWidth !== undefined ? [{ borderWidth }] : []),
            disabledContainerStyle,
            Platform.OS === "web" &&
                (isHoverActive || isFocusActive) &&
                !disabled && [
                styles.inputContainerOutline,
                { outlineColor: borderColor },
            ],
        ]}>
        {icon && <Icon {...icon} size={24} color={contentColor}/>}
        <View style={styles.inputGroup}>
          {placeholder && (isFocusActive || hasValue) ? (<Text style={[styles.label, { color: contentColor }]}>
              {placeholder}
            </Text>) : null}
          <TextInputComponent ref={inputRef} testID={testID} style={[
            styles.input,
            multiline && styles.inputMultiline,
            multiline &&
                placeholder &&
                (isFocusActive || (value && value.length > 0)) &&
                styles.inputMultilineWithLabel,
            { color: contentColor },
            disabledInputStyle,
        ]} value={value} onChangeText={onChangeText} placeholder={!isFocusActive ? placeholder : undefined} placeholderTextColor={disabled ? colors.muted : undefined} secureTextEntry={!showPassword && type === "password"} onFocus={() => !readonly && !disabled && setIsFocused(true)} onBlur={(e) => {
            setIsFocused(false);
            if (onBlur)
                onBlur(e);
        }} keyboardType={type === "numeric" ? "numeric" : undefined} editable={!readonly && !disabled} accessibilityState={{ disabled }} multiline={multiline} numberOfLines={multiline ? 4 : undefined}/>
        </View>

        {type === "password" && (<TouchableOpacity style={styles.passwordIcon} onPress={togglePasswordVisibility} disabled={disabled} accessibilityState={{ disabled }}>
            <Icon iconSet="material-community" icon={showPassword ? "eye-off-outline" : "eye-outline"} size={24} color={disabled ? colors.muted : "#808080"}/>
          </TouchableOpacity>)}
        {slotRight}
      </View>
      {description && (<View style={[
                styles.descriptionTextContainer,
                { backgroundColor: colors.sectionBackground },
            ]}>
          <ThemedText type="small" style={fonts.medium}>
            {description}
          </ThemedText>
        </View>)}
      {reserveErrorSpace ? (typeof error !== "undefined" && (<View style={styles.errorText}>
            <ThemedText type="small" style={{ color: colors.danger }}>
              {error}
            </ThemedText>
          </View>)) : (<CollapsibleView isVisible={Boolean(error)} style={styles.collapsibleErrorText} testID={testID ? `${testID}-error` : undefined}>
          <ThemedText type="small" style={{ color: colors.danger }}>
            {error}
          </ThemedText>
        </CollapsibleView>)}
    </View>);
};
//# sourceMappingURL=TextInput.js.map